<mat-tab-group mat-stretch-tabs selectedIndex="1">
  @for (kd of kalps$ | async; let i = $index; track i) {
    <mat-tab [label]="kd.name + ': ' + kd.value" class="kalp-holder">
      <ng-template matTabContent>
        <spb-kalp-display [index]="i" [kalp]="kd.kalp"></spb-kalp-display>
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>